import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiBookings } from "~/routes"

import PageContainer from "~/library/PageContainer"

import BookingForm from "~/components/BookingForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import type Booking from "~/types/Booking"

const EditBooking = () => {
  const [isBookingUpdated, setIsBookingUpdated] = useState<boolean | null>(null)

  const { id } = useParams()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiBookings.show.path({ venueSlug, id })
  const { data: booking } = useFetchResource<{ booking: Booking }, "booking">(
    endpoint,
    "booking",
    {}
  )

  const handleSubmit = (formValues: any) => {
    const filteredBookingData = {
      name: formValues.name,
      date: formValues.date,
      details: formValues.details,
      anticipatedRevenueCents: formValues.anticipatedRevenueCents,
      status: formValues.status,
      areaId: formValues.areaId,
      clientId: formValues.clientId,
      packIds: formValues.packIds || [],
    }

    const data = {
      venue_slug: venueSlug,
      id: booking.id,
      booking: filteredBookingData,
    }

    const req = apiBookings.update({ data })
    req.then(() => {
      setIsBookingUpdated(true)
    })
    req.catch((res) => {
      toast(`Error updating Booking. ${res.body.errors.join(", ")}`, "danger")
    })
  }

  if (isBookingUpdated) {
    return <Navigate to={`/bookings/${booking?.id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Booking</h3>
          <LoadingWrapper isLoading={!booking?.id}>
            <BookingForm onSubmit={handleSubmit} initialValues={booking} isEditing={true} />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditBooking
